import React from 'react';
import { cn } from '../../lib/utils';

const BrandWordmark = ({
  className,
  textClassName = 'text-2xl sm:text-3xl',
  dotClassName,
}) => {
  return (
    <div
      className={cn('inline-flex items-center leading-none uppercase', className)}
      style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
    >
      <span className={cn('mr-[-0.13em] font-extrabold tracking-[0.13em] text-[#E4A50E]', textClassName)}>
        DAD
      </span>
      <span
        aria-hidden="true"
        className={cn(
          'mx-[clamp(0.28rem,0.11em,0.5rem)] h-[clamp(0.52rem,0.255em,0.9rem)] w-[clamp(0.52rem,0.255em,0.9rem)] translate-y-[clamp(0.02rem,0.03em,0.1rem)] rounded-full bg-[#7A6F64]',
          dotClassName,
        )}
      />
      <span className={cn('font-extrabold tracking-[0.13em] text-[#E4A50E]', textClassName)}>
        PARTNERS
      </span>
    </div>
  );
};

export default BrandWordmark;
